import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useOutsideClick } from '@common/hooks/outsideClick';
import { useTranslation } from '@common/hooks/translation';

import { tooltipDirectionMap } from './helpers';

import './style.scss';

const TooltipDropDown = ({
  options,
  header,
  onToggle,
  className,
  closeOnChoose,
  showAsButton = false,
  ...rest
}) => {
  const [_openSection, setOpenSection] = useState(rest.openSection || false);
  const openSection = 'openSection' in rest ? rest.openSection : _openSection;
  const [openDirection, setOpenDirection] = useState('');
  const t = useTranslation();

  const wrapperRef = useOutsideClick(() => {
    setOpenDirection(null);
    setOpenSection(false);
    onToggle?.(false);
  }, []);

  const tooltipRef = useRef(null);

  const calculateDirection = () => {
    const bounding = tooltipRef.current?.getBoundingClientRect() || 0;

    const [direction] = Object
      .entries(tooltipDirectionMap)
      .find(([, checker]) => checker(bounding)) || ['upLeft'];

    // if (windowHeight - top < 450) {
    //   if (windowWidth - left < 380) {
    //     direction = 'upLeft';
    //   } else if (windowWidth - right > 1659) {
    //     direction = 'upRight';
    //   }
    // } else if (windowHeight - bottom > 450) {
    //   if (windowWidth - right < 995) {
    //     direction = 'bottomLeft';
    //   } else if (windowWidth - left > 1659) {
    //     direction = 'bottomRight';
    //   }
    // }

    setOpenDirection(direction);
  };
  const headerClick = (e) => {
    calculateDirection();
    e.stopPropagation();

    setOpenSection(!openSection);
    onToggle?.(!openSection);
  };

  const optionClick = (option, e) => {
    option.callback?.(e);
    if (openDirection) {
      onToggle?.(false);
      return setOpenSection(false);
    }

    if (closeOnChoose) {
      onToggle?.(false);
      setOpenSection(false);
    }
  };

  return (
    <div className={classnames(`t-d-container ${className}`, { 'is-open': openSection })}
         ref={wrapperRef}>
      <div className={classnames('t-d-header', { 't-d-active-state': openSection })}
           onClick={headerClick} ref={tooltipRef}>
        {header}
      </div>

      {openSection && (
        <div className={`t-d-wrapper-section t-d-active-${openDirection}`}>
          <div className="t-d-section-inner-container" onClick={(e) => e.stopPropagation()}>
            {options.map((item, index) => (item.enabled && (
                <div key={index}
                     className={`t-d-section ${item.className || ''} ${item.selected ? 't-d-section-selected' : ''}`}
                     onClick={(e) => optionClick(item, e)}>
                  <div className="t-d-section-inner">
                    {
                      item.iconName
                        ? <i className={`global-icon ${item.iconName}`}/>
                        : item.pic && <img src={item.pic}/>
                    }
                    <p className="t-d-section-name">
                      {t(...(Array.isArray(item.buttonName) ? item.buttonName : [item.buttonName]))}
                    </p>
                    {!!item.badge && <span className="t-d-section-badge">{item.badge}</span>}
                  </div>
                </div>
              )
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

TooltipDropDown.propTypes = {
  header: PropTypes.node,
  openSection: PropTypes.bool,
  onToggle: PropTypes.func,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  closeOnChoose: PropTypes.bool,
  showAsButton: PropTypes.bool
};

export default TooltipDropDown;
